import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.incident-report-xml';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsIncidentReportXmlEffects {

    IncidentReportXml$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_INCIDENT_REPORT_XML),
        mergeMap((x: ac.GetIncidentReportXmlAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getIncidentReportXml(x.incident_id).pipe(
                map((result: any) => {
                    return new ac.GetIncidentReportXmlErfolgreichAction(x.incident_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetIncidentReportXmlFehlerAction(error, x.incident_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsReportingService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsReportingService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsReportingService);
        }
        return this.service;
    }
}
